var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bslip-error-box"},_vm._l((_vm.errors),function(error,i){return _c('div',{key:i,staticClass:"bslip-warning-box fadeInDown"},[_c('BetslipError',{attrs:{"error":error}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }